/*
 Created by CHT 2019/12/5 16:31
*/
import Calendar from "./Calendar"
import DataGrid from "./DataGrid"
import Detailed from "./Detailed"
import FilterBtn from "./FilterBtn"
import FilterControl from "./FilterControl"
import MediaChart from "./MediaChart"
import Statistics from "./Statistics"
import TextGrid from "./TextGrid"
import Shortcut from "./Shortcut"
import TodoChart from "./TodoChart"
import FlowChart from "./FlowChart"
import CustomChart from "./CustomChart";

export default {
  Calendar,

  DataGrid,
  Detailed,
  FilterBtn,
  FilterControl,
  MediaChart,
  Statistics,
  TextGrid,
  Shortcut,
  TodoChart,
  FlowChart,
  CustomChart
}
